export class Alert {
  status: Alert.Status;
  summary: string | undefined;
  detail: { key: string; params: { [p: string]: string } } | undefined;

  constructor(status: Alert.Status, summary?: string, detail?: { key: string, params: { [key: string]: string } }) {
    this.status = status;
    this.summary = summary;
    this.detail = detail;
  }
}

export module Alert {
  export enum Status {
    WARN = 'WARN',
    SUCCESS = 'SUCCESS',
    ERROR = 'ERROR'
  }
}
